module.exports = __webpack_public_path__ + "img/170524.d253531c.png";